// extracted by mini-css-extract-plugin
export default {"gates":"bd832e658b3828cd","gate":"ef928a843a6bb941","link":"_857266275c3af045","gateInfoWrapper":"_1a25f52665ba4f27","tooltipTitle":"_4c7c5e49e42cca35"};